export default __webpack_public_path__ + "static/media/XLM.5a80b583.png";